<template>
  <div class="category">
    <ul class="category-list">
      <li class="category-list-item" v-for="(item, index) in helplist" :key="index">
        <a class="category-list-item-content">
          <span
            class="category-list-item-content-title"
            v-text="item.text"
            @click="handleJump(item)"
          ></span>
          <i class="category-list-item-content-icon"></i>
        </a>
      </li>
    </ul>
  </div>
</template>
<style lang="less" scoped>
  @import 'appImHelper.less';
</style>
<script>
import native from '@zz-common/native-adapter'
// import { lego } from '@zz-common/lego'
const HELPLIST = [
  {
    text: '交易小常识',
    url:
        'https://pic3.zhuanstatic.com/zhuanzh/e16b7229-ef02-4f8e-917c-185ed382d4c1.png'
  },
  {
    text: '防骗小知识',
    url:
        'https://pic1.zhuanstatic.com/zhuanzh/a6fe2289-ef42-41aa-b85a-575283c45e70.png'
  },
  {
    text: '我被骗了怎么办',
    url:
        'https://pic6.zhuanstatic.com/zhuanzh/e8289de5-9a73-4529-af78-7b432272077b.jpg'
  },
  {
    text: '直接微信转账被骗怎么办',
    url: 'https://pic3.zhuanstatic.com/zhuanzh/31702c1e-1171-4084-a8b8-983bbf17fda3.png'
  }
]

export default {
  data() {
    return {
      helplist: HELPLIST
    }
  },
  created() {
    native.setTitle({
      title: '帮助指南'
    })
  },
  methods: {
    handleJump: function(item) {
      native.skipToUrl({
        targetUrl: item.url,
        newPageTitle: item.text
      })
    }
  }
}
</script>
